/**
 * swrvにデフォルト設定を適用するための薄いラッパー
 *
 * @see https://github.com/Kong/swrv
 */

import _useSWRV from 'swrv';
import { IConfig, IKey, IResponse, fetcherFn } from 'swrv/dist/types';

const defaultConfig = {
  revalidateOnFocus: false,
};

export const useSWRV = <Data = any, Error = any>(
  key: IKey,
  fn?: fetcherFn<Data>,
  config?: IConfig
): IResponse<Data, Error> => _useSWRV(key, fn, { ...defaultConfig, ...config });
